import { motion } from "framer-motion";
import { useLoading } from "@/context/loading";
import { useEffect, useState } from "react";

export default function ArtistHero() {
  const { isLoading } = useLoading();

  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShouldAnimate(true);
    }
  }, [isLoading]);

  const containerVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.4, 0, 0.2, 1],
      },
    },
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 10,
      },
    },
  };

  const videoVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
      },
    },
  };

  return (
    <div>
      <div
        id="artists-hero-section"
        className="px-3 lg:pt-[80px] lg:pb-[6px] lg:px-[75px]"
      >
        <div className="flex flex-col lg:flex-row w-full lg:min-h-[500px] items-center lg:gap-[60px]">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate={shouldAnimate ? "visible" : "hidden"}
            className="w-full py-5 px-6 lg:px-0 lg:py-0 order-1 lg:w-[43%]"
          >
            <motion.p
              variants={itemVariants}
              className="text-[30px] leading-[32px] lg:text-[48px] font-[700] lg:leading-[54px]"
            >
              Music As A Day Job
            </motion.p>
            <motion.p
              variants={itemVariants}
              className="text-white text-base leading-[20px] font-[400] lg:text-white lg:text-[30px] lg:leading-[35px] indent-px mt-6"
            >
              Learn what Qoncert Stage you&apos;re in now and the steps you need
              to grow your fan base and maximize your income.
            </motion.p>

            <motion.button
              variants={buttonVariants}
              onClick={() => {
                window.open("https://play.qoncertapp.com/more-shows", "_blank");
              }}
              className="mt-7 w-full bg-white text-black font-[900] lg:text-[22px] lg:w-[70%] lg:py-2 rounded-xl py-3 hover:bg-gray-100 transition-colors"
            >
              Book a Show
            </motion.button>
          </motion.div>
          <motion.div
            variants={videoVariants}
            initial="hidden"
            animate={shouldAnimate ? "visible" : "hidden"}
            className="w-full lg:order-2 lg:w-[58%]"
          >
            <video
              id="heroVideo"
              className="object-cover aspect-[2/1] max-h-[380px] w-full rounded-lg lg:aspect-[1.41/1]"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={"/assets/video2.mp4"} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
